import { HearderPage } from "../componentes/HearderPage";

export function HomeApp() {
  return <HearderPage />;
}
